import clsx from 'clsx';
import React from 'react';
import './MaintenanceHeading.scss';
export const MaintenanceHeading = ({ className, name, subtitle, title }) => (React.createElement("div", { className: clsx('feature-heading', className) },
    name && React.createElement("p", { className: "feature-heading--name" }, name),
    React.createElement("h3", { className: "feature-heading--title" }, title),
    subtitle && React.createElement("p", { className: "feature-heading--subtitle" }, subtitle)));
